<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form" style="width:60%;">
               <div class="mcf-page-editor-header">
                    <label>Sélection des produits</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <div class="mcf-page-editor-menu-search">
                        <input v-model="txtsearch" type="text" placeholder="Rechercher">
                    </div>
                    <button style="position:absolute;right:100px;" @click="bt_save">
                        <i class="fa fa-save"></i>
                        <label>Enregistrer</label>
                    </button>
                    <button style="position:absolute;right:3px;" @click="bt_cancel">
                        <i class="fa fa-times"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div class="mcf-products-form">
                    <div class="mcf-products-selection">
                        <div @click="bt_select(c)" v-for="c of list" :key="c.id" class="mcf-products-selection-item">
                            <div class="mcf-products-selection-item-content">
                                <label style="font-weight: bold;color:var(--C2);">{{c.reference}} <b v-if="c.field1!=''"> ( {{ c.field1 }}</b><b v-if="c.field2!=''"> - {{ c.field2 }}</b><b v-if="c.field1!=''"> )</b></label>
                                <label>{{c.label}}</label>
                                <label style="font-weight:bold;">{{$filters.money(c.selling_price,lang)}}</label>
                            </div>
                            <div class="mcf-products-selection-item-menu">
                                <button v-if="(c.qtycmd<c.qtydispo) && c.qtydispo>0" class="mcf-button"><i class="fa fa-plus"></i></button>
                                <button v-if="(c.qtycmd>=c.qtydispo) && c.qtydispo>0" class="mcf-button-disabled"><i class="fa fa-plus"></i></button>
                                <button v-if="c.qtydispo<=0" class="mcf-button-disabled"><i class="fa fa-ban"></i></button>
                            </div>
                        </div>
                    </div>
                    <div class="mcf-products-basket">
                        <div class="mcf-products-basket-title">
                            <label><i class='fa fa-cart-shopping'></i> Panier</label>
                        </div>
                        <div class="mcf-products-basket-list">
                            <div v-for="b of basket" :key="b.id" class="mcf-products-basket-list-item">
                                <div class="mcf-products-basket-list-item-content">
                                    <label style="font-weight: bold;color:var(--C2);">{{b.reference}}</label>
                                    <label>{{b.label}}</label>
                                    <label style="font-weight:bold;">{{$filters.money(b.selling_price,lang)}}</label>
                                </div>
                                <div class="mcf-products-basket-list-item-qty">
                                    <button v-if="b.qtycmd>1" @click="bt_qty_minus(b)">-</button>
                                    <button v-if="b.qtycmd==1" @click="bt_qty_minus(b)"><i class="fa fa-trash"></i></button>
                                    <input disabled type="number" v-model="b.qtycmd">
                                    <button v-if="b.qtycmd<b.qtydispo" @click="bt_qty_plus(b)">+</button>
                                    <button v-if="b.qtycmd==b.qtydispo"><i class="fa fa-ban"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="mcf-products-basket-recap">
                            <label>Total : {{$filters.money(total,lang)}}</label>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";
import apiproduct from "../data/product";

export default {
    props:{
        account:Object,
        cancel:Function,
        select:Function
    },
    data(){
        return {
            txtsearch:'',
            lang:'fr-FR',
            products:[]
        };        
    },
    computed: {
        list:function(){
            var tmain = this;
            var l = [];
            // var monRegEx = /^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ._\s-]{5,60}$/;
            var txt = tmain.txtsearch.toLowerCase();
            l = tmain.products.filter(x=>x.reference.toLowerCase().indexOf(txt)>-1 || x.label.toLowerCase().indexOf(txt)>-1 || x.family.toLowerCase().indexOf(txt)>-1 || x.subfamily.toLowerCase().indexOf(txt)>-1);
            return l;
        },
        basket:function(){
            var tmain = this;
            return tmain.products.filter(x=>x.qtycmd>0);
        },
        total:function(){
            var tmain = this;
            var tot = 0;
            for(var l of tmain.products.filter(x=>x.qtycmd>0)){
                tot += (l.qtycmd * l.selling_price);
            }
            return tot;
        }
    },
    created: async function() {
        var tmain = this;
        var pkg = await apiproduct.list_selection();
        if (pkg.code==0){
            tmain.products = pkg.data;
        }
    },
    methods:{
        bt_cancel:function(){
            this.cancel();
        },
        bt_select:function(item){
            if (item.qtycmd<item.qtydispo){
                item.qtycmd += 1;
            }
        },
        bt_qty_minus:function(item){
            if (item.qtycmd>0){
                item.qtycmd -= 1;
            }
        },
        bt_qty_plus:function(item){
            if (item.qtycmd<item.qtydispo){
                item.qtycmd += 1;
            }
        },
        bt_save: function(){
            this.select(this.basket);
        }
    }
}
</script>